import React, { useEffect, useState } from 'react';
import { adminContacts } from '../../lib/api';
import { Loader2 } from 'lucide-react';
import { Badge } from '../../components/ui/badge';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { adminContacts().then(setMessages).catch(console.error).finally(() => setLoading(false)); }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-neutral-400" /></div>;

  return (
    <div>
      <h1 className="text-2xl font-black mb-1">Contact Messages</h1>
      <p className="text-sm text-neutral-500 mb-6">{messages.length} messages received</p>

      {messages.length === 0 ? (
        <div className="bg-white rounded-lg p-12 text-center border">
          <p className="text-neutral-500">No contact messages yet.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map(m => (
            <div key={m.id} className="bg-white rounded-lg p-5 border">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-bold">{m.name}</span>
                    <Badge variant="secondary">{m.reason}</Badge>
                  </div>
                  <a href={`mailto:${m.email}`} className="text-sm text-blue-600 hover:underline">{m.email}</a>
                </div>
                <span className="text-xs text-neutral-500">{new Date(m.created_at).toLocaleString()}</span>
              </div>
              <p className="mt-3 text-sm text-neutral-700 whitespace-pre-wrap">{m.message}</p>
              <div className="mt-3">
                <a href={`mailto:${m.email}?subject=Re: Your message to Fitness Pro Nutrition`} className="text-sm font-semibold text-[#0a0a0a] hover:underline">Reply via email →</a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminMessages;
